import { useMutation } from '@apollo/client'
import { REMOVE_TEST_SESSION_MEMBER } from './operations'
import { RemoveTestSessionMember, RemoveTestSessionMemberVariables } from '../../types'

export const useRemoveTestSessionMember = () =>
  useMutation<RemoveTestSessionMember, RemoveTestSessionMemberVariables>(REMOVE_TEST_SESSION_MEMBER)
